import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import type { ILead } from 'src/services/api';
import { FlexColumn } from 'src/components/flex';
import { useUpdateLead } from 'src/services/api';
import type { IUser } from 'src/api/users-api';

interface Props {
    open: boolean;
    onClose: () => void;
    type: 'phone' | 'email';
    value: string;
    lead: ILead;
    loggedInUser: IUser;
}

export default function ContactInfoModal({
    open,
    onClose,
    type,
    value,
    lead,
    loggedInUser,
}: Props) {
    const { mutate: updateLead } = useUpdateLead(lead.uuid);

    const handleUpdateLead = async () => {
        updateLead({
            uuid: lead.uuid,
            name: lead.name,
            email: type === 'email' ? value : lead.email,
            phone_number: type === 'phone' ? value: lead.phone_number,
            property_id: lead.property_id,
            owner: loggedInUser.id
        });
        onClose();
    };

    const leadEmail = lead.email;
    const leadPhoneNumber = lead.phone_number;

    const contactInfoType = type === 'phone' ? 'Phone Number' : 'Email Address';
    const newContactInfoText = `Would you like to add this ${contactInfoType.toLowerCase()} to the lead?`;
    const contactInfoToAdd = type === 'phone' ? leadPhoneNumber : leadEmail;
    const updateContactInfoText = `You have ${contactInfoToAdd} as the ${contactInfoType.toLowerCase()} for this lead. Would you like to update it?`;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                {contactInfoType}
            </DialogTitle>
            <DialogContent>
                <FlexColumn gap={2}>
                    <Typography variant="body1">
                        {value}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {contactInfoToAdd ? updateContactInfoText : newContactInfoText}
                    </Typography>
                </FlexColumn>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={handleUpdateLead} variant="contained">
                    {contactInfoToAdd ? 'Update' : 'Add'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}